import {Component} from '@angular/core';

@Component({
    selector: 'app-commission-queue',
    templateUrl: './commission-queue.component.html',
    standalone: false
})
export class CommissionQueueComponent {

}
